import { NgxSliderModule } from '@angular-slider/ngx-slider';
import { PortalModule } from '@angular/cdk/portal';
import { CdkStepperModule } from '@angular/cdk/stepper';
import { CommonModule, TitleCasePipe } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgbActiveModal, NgbModule, NgbPaginationModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { TranslateModule } from '@ngx-translate/core';
import { DigitOnlyModule } from '@uiowa/digit-only';
import { InlineSVGModule } from 'ng-inline-svg-2';
import { FileUploadModule } from 'ng2-file-upload';
import { ClipboardModule } from 'ngx-clipboard';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { QuillModule } from 'ngx-quill';
import { UiSwitchModule } from 'ngx-ui-switch';
import { PowerBIEmbedModule } from 'powerbi-client-angular';
import { SwiperModule } from 'swiper/angular';
import { TutorialService } from '../core/services/tutorial.service';
import { CoreSharedModule } from '../shared-modules/core-shared/core-shared.module';
import { COMPONENTS } from './components';
import { MEDProcessAndDisplayCustomTagsComponent } from './components/MED-process-and-display-custom-tags/MED-process-and-display-custom-tags.component';
import { MEDResearchStudyIDComponent } from './components/MED-process-and-display-research-study-id/MED-process-and-display-research-study-id.component';
import { SelectedFilesComponent } from './components/create-and-start-dialog/selected-files/selected-files.component';
import { CsvTableComponent } from './components/csv-table/csv-table.component';
import { FilesUploadButtonComponent } from './components/files-upload-button/files-upload-button.component';
import { ResultFeedbackModalComponent } from './components/send-result-feedback-button/result-feedback-modal/result-feedback-modal.component';
import { SupportedFormatsDialogComponent } from './components/supported-formats-dialog/supported-formats-dialog.component';
import { MEDUploadDataDialogComponent } from './components/upload-data-MED/MED-upload-data-dialog.component';
import { UploadProgressContainerComponent } from './components/upload-progress-container/upload-progress-container.component';
import { DIRECTIVES } from './directives';
import { TruncateDirective } from './directives/truncate/truncate.directive';
import { PIPES } from './pipes';
import { FileSizePipe } from './pipes/file-size/file-size.pipe';
import { FilterPipe } from './pipes/filter/filter.pipe';
import { FullNameWithEmailPipe } from './pipes/full-name-with-email/full-name-with-email.pipe';
import { FullNamePipe } from './pipes/full-name/full-name.pipe';
import { PercentagePipe } from './pipes/percentage/percentage.pipe';

const MODULES = [
    CommonModule,
    TranslateModule,
    FormsModule,
    ReactiveFormsModule,
    NgbModule,
    FileUploadModule,
    ClipboardModule,
    NgSelectModule,
    UiSwitchModule,
    InlineSVGModule,
    NgbPaginationModule,
    NgxSliderModule,
    CdkStepperModule,
    PortalModule,
    InfiniteScrollModule,
    SwiperModule,
    DigitOnlyModule,
    CoreSharedModule,
    PowerBIEmbedModule,
];

@NgModule({
    declarations: [
        ...COMPONENTS,
        ...DIRECTIVES,
        ...PIPES,
        CsvTableComponent,
        ResultFeedbackModalComponent,
        SelectedFilesComponent,
        SupportedFormatsDialogComponent,
        TruncateDirective,
        UploadProgressContainerComponent,
        FilesUploadButtonComponent,
        MEDProcessAndDisplayCustomTagsComponent,
        MEDResearchStudyIDComponent,
        MEDUploadDataDialogComponent,
    ],
    imports: [RouterModule, ...MODULES, QuillModule.forRoot()],
    providers: [NgbActiveModal, FilterPipe, TitleCasePipe, FullNamePipe, FullNameWithEmailPipe, FileSizePipe, PercentagePipe, TutorialService],
    exports: [QuillModule, ...COMPONENTS, ...DIRECTIVES, ...PIPES, ...MODULES],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class SharedModule {}
